import React from "react"
import { FormControl } from "react-bootstrap"

import { RequiredFieldWarning } from "../../internationalization/LocaleFormatted"
import InfoPopover from "../../../shared_components/widgets/InfoPopover"
import FormLabel from "./FormLabel"

export default function InputFormField({
  intl,
  type = "text",
  description,
  label,
  placeholder,
  value,
  updateFormValue,
  field,
  warning,
  warningField,
  canEdit = true,
  InputToggle,
  ValuePlaceholder,
  info_desc = "",
  hasChanged = false,
}) {
  return (
    <div className={"one-rem-margin-bottom"}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <FormLabel
          description={description}
          label={label}
          hasChanged={hasChanged}
          required={warningField && canEdit}
        />
        {InputToggle && InputToggle}
        {info_desc && (
          <div>
            <InfoPopover desc={info_desc} placement={"bottom"} />
          </div>
        )}
      </div>
      {ValuePlaceholder ? (
        <>{ValuePlaceholder}</>
      ) : (
        <FormControl
          type={type}
          as={type === "textarea" ? type : "input"}
          rows={4}
          placeholder={placeholder ? intl.formatMessage({ id: `${placeholder}` }) : ""}
          value={value || ""}
          onChange={(e) => updateFormValue(e, field, e.target.value, warningField)}
          disabled={!canEdit}
          onWheel={(e) => e.target.blur()}
        />
      )}
      <div>{warningField && canEdit && <RequiredFieldWarning warning={warning} />}</div>
    </div>
  )
}
